import React, { useState } from 'react';
import { useI18n } from '../../lib/i18n';
import { Reveal } from '../ui/Reveal';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { Textarea } from '../ui/Textarea';
import { Button } from '../ui/Button';
import { CheckCircle2Icon } from 'lucide-react';
export function LeadForm() {
  const {
    t
  } = useI18n();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
    }, 1500);
  };
  return <section id="consultation" className="py-24 md:py-32 relative bg-fog-gradient" data-id="element-129">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-130">
        <Reveal data-id="element-131">
          <div className="text-center mb-16" data-id="element-132">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-medium text-luxury-white mb-6" data-id="element-133">
              {t('formTitle')}
            </h2>
            <p className="text-luxury-white/70 font-light text-lg" data-id="element-134">
              {t('formSub')}
            </p>
          </div>
        </Reveal>

        <Reveal delay={200} data-id="element-135">
          <div className="glass-panel-dark p-8 md:p-12 rounded-[2rem]" data-id="element-136">
            {isSuccess ? <div className="flex flex-col items-center justify-center py-16 text-center animate-fade-in" data-id="element-137">
                <div className="w-16 h-16 bg-luxury-gold/15 rounded-full flex items-center justify-center mb-6" data-id="element-138">
                  <CheckCircle2Icon className="w-8 h-8 text-luxury-gold" data-id="element-139" />
                </div>
                <h3 className="text-2xl font-heading text-luxury-white mb-4" data-id="element-140">
                  {t('formSuccess')}
                </h3>
                <p className="text-luxury-white/70" data-id="element-141">{t('formMicro')}</p>
              </div> : <form onSubmit={handleSubmit} className="space-y-8" data-id="element-142">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-143">
                  <Input label={t('fName')} required placeholder="Jane Doe" data-id="element-144" />
                  <Input label={t('fEmail')} type="email" required placeholder="jane@example.com" data-id="element-145" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-146">
                  <Input label={t('fPhone')} type="tel" placeholder="+1 (555) 000-0000" data-id="element-147" />
                  <Input label={t('fCompany')} required placeholder="Company Name" data-id="element-148" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-149">
                  <Select label={t('fIndustry')} required defaultValue="" options={[{
                value: 'private-travel',
                label: t('fIndOpt1')
              }, {
                value: 'superyachts',
                label: t('fIndOpt2')
              }, {
                value: 'residential',
                label: t('fIndOpt3')
              }, {
                value: 'hospitality',
                label: t('fIndOpt4')
              }, {
                value: 'other',
                label: t('fIndOpt5')
              }]} data-id="element-150" />
                  <Input label={t('fLocation')} required placeholder="City, Country" data-id="element-151" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-152">
                  <Select label={t('fTimeline')} required defaultValue="" options={[{
                value: 'asap',
                label: t('fTimeOpt1')
              }, {
                value: '1-3',
                label: t('fTimeOpt2')
              }, {
                value: '3-6',
                label: t('fTimeOpt3')
              }, {
                value: '6+',
                label: t('fTimeOpt4')
              }]} data-id="element-153" />
                  <Select label={t('fBudget')} defaultValue="" options={[{
                value: 'hidden',
                label: t('fBudOpt1')
              }, {
                value: '25-100',
                label: '25k – 100k'
              }, {
                value: '100-250',
                label: '100k – 250k'
              }, {
                value: '250+',
                label: '250k+'
              }]} data-id="element-154" />
                </div>

                <Textarea label={t('fMessage')} placeholder="Tell me about your project..." data-id="element-155" />

                <div className="pt-6 flex flex-col items-center gap-6" data-id="element-156">
                  <Button type="submit" fullWidth disabled={isSubmitting} className="md:w-auto md:min-w-[300px]" data-id="element-157">
                    {isSubmitting ? '...' : t('formSubmit')}
                  </Button>
                  <p className="text-xs text-luxury-white/50 tracking-wide" data-id="element-158">
                    {t('formMicro')}
                  </p>
                </div>

                {/* API Integration Note */}
                {/* To connect to backend, replace handleSubmit logic with fetch/axios call to your endpoint */}
              </form>}
          </div>
        </Reveal>
      </div>
    </section>;
}